/**************************************************
 * Nombre:       Tabla_Normal_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Paper, Table, TableBody, TableContainer, TableHead, Typography} from "@mui/material";
import BarraInferior from "../ComponentesTabla/BarraInferior";
import CabeceraTabla from "../ComponentesTabla/CabeceraTabla";
import Esqueleto_Cuerpo_Tabla from "../Esqueletos/Esqueleto_Cuerpo_Tabla";
import CuerpoTabla from "../ComponentesTabla/CuerpoTabla";
import BotonTransparente from "../../../../Dashboard/Tarjetas_Especiales/Componentes/BotonTransparente";
import {Add} from '@mui/icons-material'
import {useResponsive} from "../../../../Modulo_Responsive/Hooks/useResponsive";

const Tabla_Normal_Soporte = ({
                                  data = [],
                                  datosCabecera = [],
                                  numeroFilas,
                                  filasPagina,
                                  page,
                                  cambiarPagina,
                                  filasPaginaCambia,
                                  estado,
                                  setEstado,
                                  funcionBuscar,
                                  cargando,
                                  botones,
                                  clickAgregar,
                                  botonesData,
                                  clickData

                              }) => {
    const {sCell} = useResponsive()

    return (

        <TableContainer component={Paper} sx={{boxShadow: 0, backgroundColor: '#00000000'}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', alignItems: 'center', position: 'sticky', left: '0%'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{color: '#fff', fontWeight: 600, fontSize: 18}}>Tickets de Soporte</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 2}} sx={{justifyContent: 'flex-end', mt: sCell ? 2 : 0}}>
                        <BotonTransparente click={clickAgregar} Icono={Add} titulo={'Crear Ticket'}/>
                    </Grid>

                </Grid>

            </Grid>

            <Table aria-label="simple normal"
                   stickyHeader
                   sx={{backgroundColor: '#00000000', mt: 1}}
            >
                <TableHead>
                    <CabeceraTabla datosCabecera={datosCabecera} estado={estado} setEstado={setEstado}/>
                </TableHead>

                <TableBody sx={{minHeight: 50}}>


                    {cargando ?
                        <Esqueleto_Cuerpo_Tabla datosCabecera={datosCabecera}/>
                        :
                        <CuerpoTabla data={data} datosCabecera={datosCabecera} botonesData={botonesData}
                                     clickData={clickData}/>
                    }

                </TableBody>
            </Table>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginTop: 2,
                position: 'sticky', left: '0%'
            }}>

                <BarraInferior numeroFilas={numeroFilas}
                               filasPagina={filasPagina}
                               page={page}
                               cambiarPagina={cambiarPagina}
                               filasPaginaCambia={filasPaginaCambia}
                               funcionBuscar={funcionBuscar}
                               clickAgregar={clickAgregar}
                               cargando={cargando}
                               botones={botones}/>

            </Grid>

        </TableContainer>

    )

}
export default Tabla_Normal_Soporte



